import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FormField, FormFieldType } from '@models/client-intake';
import {
	CoreDatepickerComponent,
	CoreInputComponent,
	CoreInputPercentComponent,
	CoreRadioGroupComponent,
	CoreSelectComponent,
	FormOption,
} from '@core/ui';

import { FileInputFieldComponent } from './file-input-field/file-input-field.component';

@Component({
	selector: 'app-form-field',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		CoreInputComponent,
		FileInputFieldComponent,
		CoreRadioGroupComponent,
		CoreDatepickerComponent,
		CoreSelectComponent,
		CoreInputPercentComponent,
	],
	templateUrl: './form-field.component.html',
})
export class FormFieldComponent {
	@Input() field!: FormField;
	@Input() control!: FormControl;

	FormFieldTypeEnum = FormFieldType;

	get selectOptions(): Array<FormOption<unknown>> {
		return (
			this.field.options?.map((opt) => ({
				id: opt.id,
				label: opt.label || '',
				value: opt.id,
			})) || []
		);
	}
}
